import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { Report } from "notiflix/build/notiflix-report-aio";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import api from "../../../helpers/apiRequester";
import { Button, Card, Column, DataTable, Input, Section } from "../../../ui";
export interface statsProps {
    dataType: string;
    data: any;
    dataViewTitle: string;
    search: boolean;
    pagination?: boolean;
}
export const ClientsView = (props: statsProps) => {
    const navigate = useNavigate();
    const { data, dataType, dataViewTitle, search, pagination } = props;
    const [showStats, setShowStats] = useState(false);
    const [tableData, setTableData] = useState(data);
    const [searchTerm, setSearchTerm] = useState("");
    const [paginationPosition, setPaginationPosition] = useState(0);
    const [showPagination, setShowPagination] = useState(pagination);

    useEffect(() => {
        if (!showStats && data && data.length > 0) {
            setTableData(data);
            setShowStats(true);
        }
    }, [data]);

    const viewClient = (client_id: string) => {
        navigate("/view-client/" + client_id);
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    };

    const onChange = async (e: React.FormEvent<HTMLInputElement>) => {
        const newValue = e.currentTarget.value;
        setSearchTerm(newValue);

        if (newValue.length > 2) {
            try {
                const apiResult = await api({
                    url: "search-client",
                    data: { term: searchTerm },
                });
                if (apiResult.data.results.length < 1) {
                    return Report.failure("No Result", "No results match that search term.", "Okay");
                }

                setShowPagination(false);
                setTableData(apiResult.data.results);
            } catch (error) {
                Report.failure("Search Error Occurred", "An error occurred whilst searching for your term. Please contact administrator.", "Okay");
            }
        }
        if (newValue.length == 0) {
            setTableData(data);
            setShowPagination(true);
            setPaginationPosition(0);
        }
    };
    const paginate = async (forward: boolean) => {
        const position = forward ? paginationPosition + 1 : paginationPosition - 1;
        const paginatedData = await api({ url: "paginate-clients", data: { position: position * 50 } });
        if (paginatedData.data.success) {
            const results = paginatedData.data.results;
            setPaginationPosition(position);
            setTableData(results);
        }
    };

    const columns = getColumns(dataType, viewClient);

    return (
        <Section title={dataViewTitle} className={styles.dataView}>
            {search ? (
                <form onSubmit={(e) => handleSubmit(e)} className={styles.searchForm}>
                    <Input className={styles.search} type="search" onChange={onChange} placeholder="Search by name" aria-label="Search clients" />
                </form>
            ) : null}
            <Card padding="none">
                <DataTable
                    bare
                    columns={columns}
                    rows={showStats ? tableData ?? [] : []}
                    rowKey={(row: any, i) => row.id ?? i}
                    onRowClick={(row: any) => viewClient(row.id)}
                    emptyTitle="No clients to show"
                    footer={
                        showPagination ? (
                            <div className={styles.pagination}>
                                <span className={styles.pageLabel}>Page {paginationPosition + 1}</span>
                                <div className={styles.pageButtons}>
                                    <Button variant="neutral" size="sm" icon={<FaChevronLeft />} disabled={paginationPosition <= 0} onClick={() => paginate(false)}>
                                        Back
                                    </Button>
                                    <Button variant="neutral" size="sm" iconRight={<FaChevronRight />} onClick={() => paginate(true)}>
                                        Next
                                    </Button>
                                </div>
                            </div>
                        ) : undefined
                    }
                />
            </Card>
        </Section>
    );
};

const getColumns = (type: string, viewClient: (client_id: string) => void): Column<any>[] => {
    switch (type) {
        case "ALL":
            return [
                { key: "id", header: "Client ID", nowrap: true, render: (row) => <span className={styles.mono}>{row.id}</span> },
                { key: "name", header: "Client Name" },
                { key: "email", header: "Client Email", truncate: true },
                { key: "phone", header: "Client Telephone", nowrap: true },
                {
                    key: "action",
                    header: "Action",
                    align: "right",
                    render: (row) => (
                        <Button
                            variant="neutral"
                            size="sm"
                            onClick={(e) => {
                                e.stopPropagation();
                                viewClient(row.id);
                            }}
                        >
                            View Client
                        </Button>
                    ),
                },
            ];
        default:
            return [];
    }
};
